import { Card, CardProps } from 'antd'
import styles from './styles.module.scss'

const BaseLayout: React.FC<CardProps> = ({ className, ...props }) => {
  const classNameValue = `${className} ${styles.baseLayout}`
  return <Card {...props} className={classNameValue} />
}

export default BaseLayout
